import React from 'react'
import HTTPInternalErrorContainer from 'src/containers/Error/500'

const HTTPInternalErrorPage: React.FC = () => {
  return <HTTPInternalErrorContainer />
}

export const PATH = '/500' as const
export default HTTPInternalErrorPage
